module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "设置规则名称",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "limit_name",
      "rules": {
        required: true,
        message: '请填写规则名称',
        trigger: 'blur'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "最多30个字"
    },
    model: {
      value: (_vm.form.limit_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_name", $$v)
      },
      expression: "form.limit_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "购买规则"
    }
  }, [_c('el-input', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "maxlength": 30
    },
    model: {
      value: (_vm.rule.day),
      callback: function($$v) {
        _vm.$set(_vm.rule, "day", $$v)
      },
      expression: "rule.day"
    }
  }), _vm._v("\n            天，购买\n            "), _c('el-input', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "maxlength": 30
    },
    model: {
      value: (_vm.rule.limit),
      callback: function($$v) {
        _vm.$set(_vm.rule, "limit", $$v)
      },
      expression: "rule.limit"
    }
  }), _vm._v("\n            件\n            "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("天数设置0视为此次活动有效期内，例如：0天，购买1件是指活动有效期内只能购买一件商品")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用会员"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.validGrade),
      callback: function($$v) {
        _vm.validGrade = $$v
      },
      expression: "validGrade"
    }
  }, [_vm._l((_vm.memberGrade), function(grade) {
    return _c('el-checkbox', {
      key: grade.grade_id,
      attrs: {
        "label": grade.grade_id
      }
    }, [_vm._v("\n                    " + _vm._s(grade.grade_name) + "\n                ")])
  }), _vm._v(" "), _vm._l((_vm.vipGrade), function(vipdata) {
    return _c('el-checkbox', {
      key: vipdata.lv_type,
      attrs: {
        "label": vipdata.lv_type
      }
    }, [_vm._v("\n                    付费" + _vm._s(vipdata.grade_name) + "\n                ")])
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "format": "yyyy/MM/dd HH:mm:ss",
      "value-format": "timestamp",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "选择限购商品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [(this.copy_flag) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("复制活动")]) : _vm._e(), _vm._v(" "), (_vm.hasSaveButton && !this.copy_flag) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f5c9b18", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f5c9b18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/goodslimit/add.vue
// module id = 2587
// module chunks = 0